import { styled, SvgIcon } from "@mui/material";
import { ReactComponent as ChatIcon } from "assets/icons/chatbot.svg";

const ChatbotIconUnstyled = ({ className, fill, stroke, fontSize }) => {
  return (
    <SvgIcon
      className={className}
      fill={fill}
      stroke={stroke}
      fontSize={fontSize}
      component={ChatIcon}
      inheritViewBox
    />
  );
};

const ChatbotIcon = styled(ChatbotIconUnstyled)({});

export default ChatbotIcon;
